// extracted by mini-css-extract-plugin
export default {"lineBreak":"lineBreak_lineBreak__OIEJY"};